import { useContext, useEffect, useRef } from 'react';

import './Loading.scss';

import AppContext from "../../../store/app-context";

/** Safety timeout: auto-dismiss a stuck overlay after 15 seconds */
const LOADING_TIMEOUT_MS = 15_000;

const Loading = () => {
    const appCtx = useContext(AppContext);
    const isVisible = appCtx.loading.length > 0;
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    // Safety net: auto-clear loading if it's been showing too long
    useEffect(() => {
        if (isVisible) {
            timeoutRef.current = setTimeout(() => {
                appCtx.newLoading('');
            }, LOADING_TIMEOUT_MS);
        }
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isVisible, appCtx.loading]);

    return (
        <div id="loading" className={isVisible ? '' : 'hide'}>
            <div className="inner">
                <div className="loading-spinner" />
                <span className="loading-text">{appCtx.loading}</span>
            </div>
        </div>
    );
};

export default Loading;